import logos from '../common/Logos';
import theme from '../../theme';
import NotificationBell from '../Notifications/NotificationBell';

function AssetList({ assets, onSelect, detailed, handleDeepFetch, isFetching }) {
  if (detailed === undefined) {
    detailed = false;
  }

  return (
    <div className="flex flex-wrap gap-2.5">
      {assets
        .filter((entry) => { return entry.isAssetActive })
        .map((asset, idx) => (
          <div key={asset.id} className="relative">
          <button
            onClick={() => onSelect(asset)}
            title={asset.symbol}
            className={`group flex items-center gap-2.5 px-3 py-2.5 pr-9 ${theme.cardBg} rounded-xl ${theme.cardBorder} cursor-pointer transition-all duration-200 hover:shadow-md hover:border-olive-300 hover:-translate-y-0.5 active:scale-[0.97] text-left`}
          >
            {asset.broker === 'okx' && (
              <img
                src={asset.symbol.includes('/')
                  ? "https://s3-symbol-logo.tradingview.com/crypto/XTVC" +
                  asset.symbol.substring(0, asset.symbol.indexOf('/')) + ".svg"
                  : logos.okx
                }
                alt="Asset logo"
                className="w-7 h-7 rounded-lg flex-shrink-0"
              />
            )}

            {detailed ? (
              <div className="min-w-0">
                <h3 className={`text-sm font-bold ${theme.textPrimary} truncate group-hover:text-olive-600 transition-colors`}>
                  {asset.broker === 'okx'
                    ? (asset.symbol.includes('/')
                      ? asset.symbol.substring(0, asset.symbol.indexOf('/'))
                      : asset.symbol
                    )
                    : asset.symbol}
                </h3>
                <p className={`text-xs ${theme.textMuted}`}>{asset.quantity}</p>
                <span className={`inline-block mt-0.5 px-1.5 py-0.5 text-[10px] font-bold rounded ${asset.side?.toUpperCase() === 'BUY'
                  ? 'bg-emerald-50 text-emerald-600'
                  : 'bg-red-50 text-red-500'
                  }`}>
                  {asset.side?.toUpperCase()}
                </span>
              </div>
            ) : (
              // Fixed width fits about five characters; the rest goes to the ellipsis and the hover title.
              <p className={`w-16 text-sm font-semibold ${theme.textSecondary} truncate group-hover:text-olive-700 transition-colors`}>
                {asset.broker === 'okx'
                  ? (asset.symbol.includes('/')
                    ? asset.symbol.substring(0, asset.symbol.indexOf('/'))
                    : asset.symbol
                  )
                  : asset.symbol}
              </p>
            )}
          </button>
            <div className="absolute right-1.5 top-1/2 z-10 -translate-y-1/2">
              <NotificationBell
                size="sm"
                align={idx === 0 ? 'left' : 'right'}
                context={{ brokers: [asset.broker], instruments: [asset.symbol] }}
                title={asset.symbol}
                onItemClick={() => onSelect(asset)}
              />
            </div>
          </div>
        ))}
    </div>
  );
}

export default AssetList;
